import { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom'
import styled from '@emotion/styled'
import {
  fetchCustomerCreditCards,
  openModal,
  selectBrand,
  selectContent,
  selectCustomer,
  selectCustomerCreditCards,
  useAppDispatch,
  useAppSelector,
} from '@open-tender/cloud'
import {
  Button,
  Content,
  HeaderUser,
  Loading,
  Main,
  Message,
  PageContainer,
  PageContent,
  PageSection,
  PageTitle,
  PageTitleButtons,
} from 'components'
import CreditCards from './CreditCards'

const CreditCardMessage = styled.div`
  text-align: center;
  margin: ${(props) => props.theme.layout.padding} auto;
  @media (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    margin: ${(props) => props.theme.layout.paddingMobile} auto;
  }
`

const AccountCreditCards = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { title: siteTitle, applePayMerchantId } =
    useAppSelector(selectBrand) || {}
  const { auth } = useAppSelector(selectCustomer)
  const { creditCards: config } = useAppSelector(selectContent) || {}
  const { entities, loading } = useAppSelector(selectCustomerCreditCards)
  const isLoading = loading === 'pending'
  const savedCards = entities.filter((i) => i.has_profile)
  const linkedCards = entities.filter((i) => !i.has_profile)
  const hasLinkedCards = !!applePayMerchantId || linkedCards.length > 0

  useEffect(() => {
    if (!auth) return navigate('/account')
  }, [auth, navigate])

  useEffect(() => {
    const includeLinked = true
    dispatch(fetchCustomerCreditCards(includeLinked))
  }, [dispatch])

  return (
    <>
      <Helmet>
        <title>
          {config?.title} | {siteTitle}
        </title>
        <script
          type="text/javascript"
          src="https://pg.feroot.com/v1/bundle/9e70ab68-af2d-4de8-a7f2-5b518104089a"
        />
      </Helmet>
      <Content>
        <HeaderUser />
        <Main>
          <PageContainer style={{ maxWidth: '76.8rem' }}>
            <PageTitle {...config}>
              <PageTitleButtons>
                <Button
                  onClick={() => dispatch(openModal({ type: 'creditCard' }))}
                >
                  Add a New Credit Card
                </Button>
              </PageTitleButtons>
            </PageTitle>
            {savedCards.length > 0 && (
              <CreditCards creditCards={savedCards} isLoading={isLoading} />
            )}
            {hasLinkedCards && (
              <PageSection
                title="Linked Cards"
                subtitle="These are cards you have saved in either Apple Pay or
                        Google Pay that have been linked with your account for
                        loyalty recognition at the point of sale in our
                        restaurants."
              >
                <PageTitleButtons>
                  <Button
                    onClick={() =>
                      dispatch(openModal({ type: 'creditCardLinked' }))
                    }
                  >
                    Add a New Linked Card
                  </Button>
                </PageTitleButtons>
                {linkedCards.length > 0 ? (
                  <CreditCardMessage>
                    <Message color="alert" size="small" as="div">
                      PLEASE NOTE: To pay with these cards ONLINE, use the Apple
                      Pay or Google Pay option on the checkout page.
                    </Message>
                  </CreditCardMessage>
                ) : (
                  <></>
                )}
                <CreditCards
                  creditCards={linkedCards}
                  isLoading={isLoading}
                  showDefault={false}
                />
              </PageSection>
            )}
            {entities.length === 0 ? (
              <PageContent>
                {isLoading ? (
                  <Loading text="Retrieving your cards on file..." />
                ) : (
                  <p>Looks like you haven't added any credit cards yet.</p>
                )}
              </PageContent>
            ) : null}
          </PageContainer>
        </Main>
      </Content>
    </>
  )
}

export default AccountCreditCards
